import { Payment } from '@apply/api/src/api/PaymentApi';
import { formatCurrency } from '@apply/ui';
import { PaymentStatusBubble } from '../../components/PaymentStatusBubble';
import { PaymentMethodBlock } from '../../components/PaymentMethodBlock';
import { PaymentStatus } from '@apply/constants';
import dayjs from 'dayjs';

interface TopSectionParameters {
    payment: Payment;
    bfiNumber: string;
    set_bfiNumber: React.Dispatch<React.SetStateAction<string>>;
    set_refundModalPayment: React.Dispatch<React.SetStateAction<Payment | undefined>>;
}

export const TopSection: React.FC<TopSectionParameters> = ({ payment, bfiNumber, set_bfiNumber, set_refundModalPayment }) => {
    const addRefundClick = () => {
        set_refundModalPayment(payment);
    };

    return (
        <>
            <div className='payment-edit-top'>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <div className='payment-edit-top-amount'>{formatCurrency(payment.amount)}</div>
                    <PaymentStatusBubble paymentStatus={payment.paymentStatus} />
                </div>
                {payment.paymentStatus == PaymentStatus.Success && (
                    <button
                        type='button'
                        className='button primary'
                        style={{ margin: 0 }}
                        onClick={addRefundClick}
                    >
                        Refund
                    </button>
                )}
            </div>
            <div className='payment-edit-top-card-summary'>
                <div>
                    <label className='payment-edit-top-label'>Last Update</label>
                    {dayjs(payment.lastUpdate).format('MMMM D, YYYY')}
                </div>
                <div>
                    <label className='payment-edit-top-label'>Customer</label>
                    {payment.customerName}
                </div>
                <div>
                    <label className='payment-edit-top-label'>BFI Number</label>
                    <input
                        id='bfiNumber'
                        type='text'
                        className='payment-edit-top-bfi-number'
                        maxLength={11}
                        value={bfiNumber}
                        onChange={(event) => set_bfiNumber(event.target.value)}
                    />
                </div>
                <div className='payment-edit-top-payment-method'>
                    <label className='payment-edit-top-label'>Payment Method</label>
                    <PaymentMethodBlock {...payment} />
                </div>
            </div>
        </>
    );
};
